@if (readonly && value != null) {
  <div class="input-container" [style.width]="width">
    <div class="header">
      <div class="label-readonly">{{ label }}</div>
    </div>

    <input
      type="text"
      class="input-readonly"
      [disabled]=true
      [(ngModel)]="value"
      [placeholder]="placeholder"
    >
  </div>

} @else {
  <div class="input-container" [style.width]="width">
    <div class="header">
      @if (label) {
        <div class="label">{{ label }}</div>
      }

      @if (link && text) {
        <div>
          <app-link [link]="link" [text]="text"></app-link>
        </div>
      } @else {
        <app-form-switch-button
          [text]="switchBtnText"
          (switchForm)="onClickBtn()"
        />
      }
    </div>

    <div
      class="input-wrapper"
      [class]="{'error': validationError || displayValidationError, 'check': checkedState, 'warn': warningState}"
    >
      <input
        type="number"
        inputmode="decimal"
        class="input"
        pattern="^[0-9]+$"
        [max]="max"
        [min]="min"
        [disabled]="isDisabled || disabled"
        [placeholder]="placeholder"
        [(ngModel)]="value"
        (blur)="onTouched()"
      >

      <i
        class="input-icon icon"
        tooltipClass="tooltip-info"
        [class]="{'ic-info-circle-16': validationError || warningState || displayValidationError || tooltipMessage, 'ic-checkmark-circle-16': checkedState}"
        [ngbTooltip]="tooltipMessage"
      >
      </i>
    </div>

    @if (helperText) {
      <div class="helper" [class]="{'error': validationError}">{{ helperText }}</div>
    }

    @if (shouldShowErrors && displayValidationError) {
      <app-validation-error [customErrors]="customErrors"/>
    }
  </div>
}

